<template>
  <v-card height="200px" class="background-surface-base">
    <EcsLoading :display="isLoading" />
    <v-card-text v-if="!isLoading" class="d-flex flex-column full-height">
      <div class="license-count flex-grow-1 d-flex align-center justify-center">
        {{ value }}
      </div>
      <div class="mt-2">
        <v-icon>{{ icon }}</v-icon> {{ label }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import EcsLoading from '@/components/ecs-spinner/EcsLoading';

export default {
  name: 'EcsLicensingCard',
  components: { EcsLoading },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.license-count {
  background-color: var(--v-info-darken2);
  font-size: 48px;
  color: white;
}
</style>
